<script lang="ts">
import { defineBlock } from '@bagelink/blox'
import { defineSchema, $ } from '@bagelink/vue'
const defaults = {
	symposiumTitle: 'Symposium Title',
	contributors: [{ id: 1, title: 'Response Title', author: 'Author Name', authorImage: '/webclip.png', name: 'Prof.', link: '/article' }],
}
const schema = defineSchema({
	symposiumTitle: $.text('Symposium Title'),
	contributors: $.array('Contributors', defineSchema({
		id: $.text('ID'),
		title: $.text('Article Title'),
		author: $.text('Author Name'),
		authorImage: $.upload('Author Image'),
		authorLink: $.text('Author Link'),
		name: $.text('Display Name'),
		link: $.text('Link'),
	}), { collapsible: true }),
})
export const SymposiumResponses = defineBlock({ thumbnail: '/block-thumbs/SymposiumResponses.svg', category: 'Content', order: 420, name: 'SymposiumResponses', label: 'Symposium Responses', icon: 'question_answer', schema, defaults })
</script>
<script setup lang="ts">


import AuthorSmallLink from '@/components/blocks/AuthorSmallLink.vue'
import { sanitizeArticleTitleHtml } from '@/utils/articleHtml'




const props = defineProps<{
	symposiumTitle?: string
	symposiumLink?: string
	contributors?: { id: number; title: string; author: string; authorImage: string; authorLink?: string; name: string; link: string }[]
}>()
</script>

<template>
	<div class="w720px mx-auto">
		<router-link :to="props.symposiumLink || '/symposium/'" class="decoration-none hover">
			<p class="txt14 color-primary mb-1">
				More Responses
			</p>
		</router-link>

		<div class="grid grid-wrap-2 gap-1">
			<div
				v-for="contributor in contributors"
				:key="contributor.id"
				class="contributor-item mb-2 m_mb-05"
			>
				<RouterLink :to="contributor.link" class="decoration-none">
					<h3 class="my-0 txt22 regular" v-html="sanitizeArticleTitleHtml(contributor.title)" />
				</RouterLink>
				<AuthorSmallLink
					:title="contributor.name"
					:name="contributor.author"
					:image="contributor.authorImage"
					:link="contributor.authorLink"
					:show-image="true"
				/>
			</div>
		</div>
	</div>
</template>

<style scoped>

</style>
